export const TICKETS_CHANGED_EVENT = 'tickets:changed';
export const PROPOSALS_CHANGED_EVENT = 'proposals:changed';

/**
 * Emits a local event (same tab) whenever tickets have changed.
 * Used as a reliable UI invalidation signal (e.g. sidebar count refresh)
 * in addition to Supabase Realtime.
 */
export function emitTicketsChanged() {
  if (globalThis.window === undefined) return;
  globalThis.window.dispatchEvent(new CustomEvent(TICKETS_CHANGED_EVENT));
}

export function subscribeToTicketsChanged(handler: () => void) {
  if (globalThis.window === undefined) return () => {};

  const listener = () => handler();
  globalThis.window.addEventListener(TICKETS_CHANGED_EVENT, listener);
  return () => globalThis.window.removeEventListener(TICKETS_CHANGED_EVENT, listener);
}

/**
 * Emits a local event (same tab) whenever AI proposals have changed.
 * Used as a reliable UI invalidation signal (e.g. sidebar count refresh)
 * in addition to Supabase Realtime.
 */
export function emitProposalsChanged() {
  if (globalThis.window === undefined) return;
  globalThis.window.dispatchEvent(new CustomEvent(PROPOSALS_CHANGED_EVENT));
}

export function subscribeToProposalsChanged(handler: () => void) {
  if (globalThis.window === undefined) return () => {};

  const listener = () => handler();
  globalThis.window.addEventListener(PROPOSALS_CHANGED_EVENT, listener);
  return () => globalThis.window.removeEventListener(PROPOSALS_CHANGED_EVENT, listener);
}
